var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center"},[_c('v-card',{staticClass:"notification-page notification-dialog",attrs:{"flat":""}},[_c('h1',[_vm._v(_vm._s(_vm.$t('notifications.name')))]),_c('NotificationList',{on:{"clickNote":function($event){return _vm.$events.fire('readNote', arguments[0])}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }